@if (isLoading()) {
  <div class="pt-32">
    <aw-loading-animation />
  </div>
} @else {
  <div class="flex justify-between pt-6 font-medium">
    <div class="flex flex-col gap-2">
      <span class="text-3xl" [attr.data-testid]="'section-header-headline'">
        <ng-content>{{ cmsTextProvider.appearanceText.headline }}</ng-content>
      </span>
      <span class="text-standard-text-secondary text-md text-xl font-normal">
        {{ cmsTextProvider.appearanceText.instructions }}
      </span>
    </div>
    <div class="flex gap-3">
      <aw-button
        id="appearance-save"
        type="submit"
        [style]="'primary'"
        [isDisabled]="!hasUnsavedChanges()"
        [text]="cmsTextProvider.shared.save"
        (click)="save()" />
      <aw-button
        id="appearance-cancel"
        type="button"
        [style]="'primary-alt'"
        [isDisabled]="!hasUnsavedChanges()"
        [text]="cmsTextProvider.shared.cancel"
        (click)="cancel()" />
    </div>
  </div>
  <aw-unfold
    [collapsed]="sectionsCollapsed()"
    (collapsedChange)="sectionsCollapsed.set($event)" />

  <div
    class="grid grid-cols-1 gap-6 py-8 lg:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <span class="text-2xl font-semibold">
      {{ cmsTextProvider.appearanceText.browserTabPreviewHeader }}
    </span>

    <div class="flex w-full max-w-6xl flex-col gap-6">
      <aw-browser-tab-preview
        [faviconUrl]="faviconPreviewUrl()"
        [title]="browserTabPreviewTitle()" />

      <div class="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <div class="flex min-w-0 flex-col gap-1">
          <div class="flex items-center gap-3">
            <aw-image-select
              id="appearance-favicon"
              class="min-w-0 flex-1"
              [allowedFileExtensions]="['ico']"
              [formControl]="faviconControl" />

            <input
              #faviconUploader
              data-testid="appearance-favicon-upload-input"
              type="file"
              hidden
              accept=".ico,image/x-icon,image/vnd.microsoft.icon"
              (change)="uploadFavicon($event)" />

            <aw-button
              id="appearance-favicon-upload"
              type="button"
              [style]="'primary-alt'"
              [isFullWidth]="false"
              [isDisabled]="imageStore.isLoading()"
              (click)="faviconUploader.click()">
              <span class="material-symbols-rounded pr-2 text-xl">{{
                cmsTextProvider.appearanceText.uploadFont
              }}</span>
              <span>{{ cmsTextProvider.appearanceText.uploadImage }}</span>
            </aw-button>
          </div>

          <span class="text-standard-text-secondary text-m">
            {{ cmsTextProvider.appearanceText.favHint }}
          </span>
        </div>

        <aw-translation-text-input
          [entityType]="EntityType.corporateDesign"
          [attr.scroll-mark]="corporateDesignForm.value.tabs?.[0]?.id"
          [relationType]="TextRelationType.tab"
          id="appearance-browser-tab-name"
          [formControl]="corporateDesignForm.controls.tabs"
          [label]="cmsTextProvider.appearanceText.browserTabName" />
      </div>
    </div>
  </div>
  <hr />

  <div
    class="grid grid-cols-1 gap-6 py-8 lg:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <span class="text-2xl font-semibold">
      {{ cmsTextProvider.appearanceText.elementForm }}
    </span>

    <div class="flex w-full max-w-4xl flex-col gap-2">
      <a
        href="/cms/corporate-design"
        class="text-primary-main flex items-center gap-1 text-lg">
        <span>{{ cmsTextProvider.appearanceText.linkToCorporateDesign }}</span>
        <span class="material-symbols-rounded text-primary-main text-lg">
          {{ cmsTextProvider.appearanceText.openLinkIcon }}
        </span>
      </a>

      <div class="text-standard-text-secondary max-w-4xl text-base leading-6">
        <span>{{ cmsTextProvider.appearanceText.corporateDesignHint }}</span>
      </div>
    </div>
  </div>
  <hr />

  <div class="py-6">
    <aw-appearance-standard-controls
      [designForm]="corporateDesignForm"
      [forceCollapse]="sectionsCollapsed()" />
  </div>
  <hr />

  <div class="py-6">
    <aw-appearance-highlighted-actions
      [designForm]="corporateDesignForm"
      [forceCollapse]="sectionsCollapsed()"
      (fontDraftChange)="setHasUnsavedChanges($event)" />
  </div>
  <hr />
}
